import { RbacRoleType } from '../rbac';

export enum StudioRole {
  Admin = 20,
  Owner = 10,
}
export enum StudioRoleName {
  Admin = 'Admin',
  Owner = 'Owner',
}

export enum RoleType {
  Admin = 'admin',
  Owner = 'owner',
  Editor = 'editor',
  Viewer = 'viewer',
  Custom = 'custom',
}

// 审批状态：0未审批，1通过，2拒绝
export enum StudioMemberInviteStatus {
  NotApproved, // 未审批
  Passed, // 通过
  Rejected, // 拒绝
}

export interface IStudioInfo {
  readonly StudioID: string;
  readonly Name: string;
  readonly CreateTime?: Date;
  readonly Creator: string;
}

export interface IStudioRole {
  readonly UserID: string;
  readonly StudioID: string;
  readonly GameID: string;
  readonly RoleID: number;
  readonly CreateTime?: Date;
  readonly ModifyTime?: Date;
  readonly StudioRoleID: number;
  readonly UserName?: string;
}

export interface IAPIStudioInfo {
  readonly studio: IStudioInfo;
  // readonly studioRole: IStudioRole;
}

export interface IRBACMember {
  readonly userId: string;
  readonly roleId: number;
  readonly roleType: RbacRoleType;
  readonly roleName: string;
  readonly groupId: number;
  readonly groupName: string;
}

export interface IAPIStudioMemberItem {
  readonly id: number;
  readonly UserID: string;
  readonly StudioID: string;
  readonly CreateTime?: Date;
  readonly ModifyTime?: Date;
  readonly UserName?: string;
  readonly RbacMember?: ReadonlyArray<IRBACMember>;
}

export interface IRbacMemberItem {
  readonly userId: string;
  readonly roleId?: number;
  readonly roleType: RoleType;
  readonly roleName?: string;
  readonly groupId?: number;
  readonly groupName?: string;
}
export interface IAPIStudioMemberHasPermissionItem {
  readonly id: number;
  readonly UserID: string;
  readonly StudioID: string;
  readonly CreateTime: string;
  readonly ModifyTime: string;
  readonly UserName: string;
  readonly RbacMember: Array<IRbacMemberItem>;
}

export interface IStudioMemberApprovalItem {
  readonly id: number;
  readonly Username: string;
  readonly ApplyUserID: string;
  readonly RoleID: StudioRole;
  readonly Reason: string;
  readonly Status: StudioMemberInviteStatus;
  readonly StudioID: string;
  readonly CreateTime: string;
  readonly ModifyTime: string;
}

export interface IStudioBasicInfo {
  StudioID: string;
  Name: string;
  UserID: string;
  StudioRoleID?: number;
}
// export interface IAPIStudioMemberApprovalRes {
//   readonly data: IStudioMemberApprovalItem[];
//   readonly code: number;
//   readonly msg: string;
// }
